import React from "react";
import { searchPageUrl } from "Shared/known-urls";
import { urlToString } from "Shared/url";
import classnames from "classnames";
import { translate } from "Shared/translate";
import * as styles from "./autocomplete.scss";
const SearchSuggestions = (props) => {
    const suggestions = props.lists.filter((x) => x.id == "suggestions")[0] &&
        !!props.lists.filter((x) => x.id == "suggestions")[0].items &&
        props.lists.filter((x) => x.id === "suggestions")[0]
            .items;
    return (React.createElement(React.Fragment, null, !props.thinSelection && !!suggestions && suggestions.length > 0 && (React.createElement("div", { "data-opti-id": "quicksearch-search-suggestions", className: styles.sectionLists },
        React.createElement("div", { className: classnames(styles.section, styles.searchSuggestionList), key: "Suggestions" },
            React.createElement("h4", null, translate("/QuickSearch/Suggestions")),
            React.createElement("ul", null, suggestions.map((item, j) => {
                return (React.createElement("li", { key: item.text + j },
                    React.createElement("a", { className: styles.button, href: urlToString({
                            path: searchPageUrl().url,
                            query: { q: item.text },
                        }), "data-ticket": item.ticket, onClick: () => props.onItemClick(item.text) }, item.text)));
            })))))));
};
export default SearchSuggestions;
